import createPerSliceIdSelector from '../helpers/createPerSliceIdSelector';
import getImageFromVideo from '../helpers/getImageFromVideo';
import get from '../helpers/get';
import { getSliceContent, getSliceItems } from './content';
import { getSliceItemIdsWithVisibility } from './categorised';
import { resolveResponsiveSetting } from './settings';

const getCardFormat = card => (
  (!card.image_portrait && (card.image_landscape || get(card, ['looping_video', 'aspect']) > 1))
    ? 'landscape' : 'portrait'
);

export const getSliceCardAspect = createPerSliceIdSelector(
  getSliceContent,
  content => (
    resolveResponsiveSetting(content, 'image_aspect')
  ),
);

export const getSliceColumns = createPerSliceIdSelector(
  getSliceContent,
  content => get(content, ['columns']),
);

export const getSliceMobileColumns = createPerSliceIdSelector(
  getSliceContent,
  content => get(content, ['columns_mobile']),
);

export const getSliceCardTitleLocation = createPerSliceIdSelector(
  getSliceContent,
  content => get(content, ['card_title_location']) === 'Overlay on image',
);

export const getSliceCardTitleColor = createPerSliceIdSelector(
  getSliceContent,
  content => (
    resolveResponsiveSetting(content, 'theme', setting => setting !== 'Light Text')
  ),
);

export const getSliceCardOpacity = createPerSliceIdSelector(
  getSliceContent,
  content => (
    resolveResponsiveSetting(content, 'opacity')
  ),
);

const getImage = (card, aspect) => {
  const image = card.image_portrait
    || card.image_landscape
    || getImageFromVideo(card.looping_video);
  return get(image, ['alternatives', aspect]) || image;
};

export const sanitizeCardItems = (items, aspect) => items.map(card => ({
  copy: card.copy,
  clickthrough: card.clickthrough,
  image: getImage(card, aspect),
  video: card.looping_video,
  format: getCardFormat(card),
  title: get(card, ['title', 'text']),
}));

export const getSliceCards = createPerSliceIdSelector(
  getSliceItems,
  getSliceCardAspect,
  sanitizeCardItems,
);
export const areSliceCardsMinimal = createPerSliceIdSelector(
  getSliceCards,
  cards => cards.every(({ title, copy }) => !(title || copy)),
);

export const getSliceCardsWithVisibility = createPerSliceIdSelector(
  getSliceCards,
  getSliceItemIdsWithVisibility,
  (cards, itemIdsWithVisibility) => itemIdsWithVisibility.map(
    ({ id: index, visible }) => ({ ...cards[index], visible }),
  ),
);
